import { useState, useEffect, useRef } from 'react';
import { cancelRaf, staticObjectAssign } from '../../utils/util';
function timeformat(timer, format) {
    const { days, hours, minutes, seconds } = timer;
    if (!format)
        return '';
    let formated;
    if (typeof format === 'function') {
        formated = format(timer);
    }
    else if (typeof format === 'string') {
        formated = format;
    }
    else {
        return '';
    }
    const matchRules = {
        days: { rule: 'D{1,2}', value: days },
        hours: { rule: 'H{1,2}', value: hours },
        minutes: { rule: 'm{1,2}', value: minutes },
        seconds: { rule: 's{1,2}', value: seconds },
    };
    Object.entries(matchRules).forEach(([key, val]) => {
        const { rule, value } = val;
        const reg = new RegExp(`(${rule})`).exec(formated);
        // 模板替换，当输出模板中没有天，时，分的时候要将值向低一级的单位累加
        if (reg) {
            formated = formated.replace(reg[1], reg[1].length === 1
                ? String(value)
                : String(value).padStart(reg[1].length, '0'));
        }
        else if (key === 'days') {
            matchRules.hours.value = value * 24 + matchRules.hours.value;
        }
        else if (key === 'hours') {
            matchRules.minutes.value =
                value * 60 + matchRules.minutes.value;
        }
        else if (key === 'minutes') {
            matchRules.seconds.value =
                value * 60 + matchRules.seconds.value;
        }
    });
    return formated;
}
// 根据timeStamp计算时分秒
const DAY = 86400;
const HOUR = 3600;
const MINUTE = 60;
function compute(timeStamp) {
    const second = timeStamp / 1000;
    const days = Math.floor(second / DAY);
    const hours = Math.floor((second % DAY) / HOUR);
    const leftSec = (second % DAY) % HOUR;
    const minutes = Math.floor(leftSec / MINUTE);
    const seconds = Math.floor(leftSec % MINUTE);
    return { days, hours, minutes, seconds };
}
export default function useCounter({ time = 0, format = '', onFinish, duration = 1000, countDown = true, max = Infinity, }) {
    let timer;
    let endTime;
    let counting;
    let prevStepTime = 0;
    const requestRef = useRef();
    const previousTimeRef = useRef();
    const options = {
        format,
        duration,
        max,
        onFinish,
    };
    const resetOptions = (opt) => {
        staticObjectAssign(options, opt);
    };
    const [timerInfo, setTimerInfo] = useState({
        milliseconds: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        formated: '',
    });
    const [timeSeconds, setTimeSeconds] = useState(0);
    // 设置reactive值
    function setData(current) {
        setTimerInfo((timerData) => {
            const countDetail = compute(current);
            timerData.milliseconds = current;
            staticObjectAssign(timerData, countDetail);
            options.format &&
                (timerData.formated = timeformat(timerData, options.format));
            // console.log('timerData: ', timerData);
            return Object.assign({}, timerData);
        });
    }
    useEffect(() => {
        console.log('timeSeconds: ', timeSeconds);
    }, [timeSeconds]);
    // 停止计时
    const pause = () => {
        prevStepTime = 0;
        counting = false;
        timer && cancelRaf(timer);
    };
    // 循环计算 TODO 使用requestanimationframe代替settimeout
    function countCall() {
        const nowTime = Date.now();
        const countTime = countDown
            ? Math.max(endTime - nowTime, 0)
            : Math.min(nowTime - endTime, options.max);
        const isLastStep = countTime === (countDown ? 0 : options.max);
        if (isLastStep ||
            !prevStepTime ||
            nowTime - prevStepTime >= options.duration) {
            prevStepTime = nowTime;
            setData(countTime);
        }
        // console.log('isLastStep: ', isLastStep);
        if (isLastStep) {
            pause();
            onFinish === null || onFinish === void 0 ? void 0 : onFinish();
        }
        else {
            requestAnimationFrame(countCall);
        }
    }
    const cycleTask = () => {
        requestRef.current = requestAnimationFrame(countCall);
    };
    const startNewCycle = (newTimeStamp) => {
        counting = true;
        endTime = Date.now() + (countDown ? newTimeStamp : -newTimeStamp);
        cycleTask();
    };
    const start = () => {
        if (!counting) {
            counting = true;
            cycleTask();
        }
    };
    // 重置
    const reset = (newTimeStamp) => {
        pause();
        startNewCycle(newTimeStamp);
    };
    useEffect(() => {
        return () => {
            pause();
        };
    });
    // onBeforeUnmount(pause);
    // 初始化
    useEffect(() => {
        startNewCycle(time);
    }, []);
    return {
        current: timerInfo,
        pause,
        start,
        reset,
        resetOptions,
    };
}
